import React from 'react';
// MUI
import { TextField, Chip, MenuItem } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
// Icons
import { IoIosCheckmark } from "react-icons/io";

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiSvgIcon-root': {
      color: 'white',
    },
    '& label': {
      color: '#fff',
    },
    '& label.Mui-focused': {
      color: '#fff',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#242729',
      color: 'white',
      borderColor: 'white',
      '& fieldset': {
        borderColor: 'rgba(255,255,255,0.6)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(255,255,255,0.6)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgb(255, 144, 0)'
      },
    },
  },
  option: {
    color: 'black'
  },
  chip: {
    fontSize: '0.75rem',
    fontWeight: 500,
    backgroundColor: 'rgb(255, 144, 0)',
    color: '#000',
    '& .MuiChip-deleteIcon': {
      color: '#333',
    },
  },
  helperText: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: 'rgb(156, 163, 175)',
    fontWeight: 300
  },
  listbox: {
    backgroundColor: "rgb(186, 186, 185)",
    color: "rgba(0,0,0,0.87)",
    borderRadius: '6px',
    padding: '0 6px',
    "& li": {
      width: '100%',
      fontSize: '14px',
      fontWeigth: '300',
      padding: '0',
      color: "rgba(0,0,0,0.87)",
      borderRadius: '4px',
      "&:hover": {
        backgroundColor: "rgb(4, 104, 212)",
        color: '#fff'
      },
      "&[aria-selected='true']": {
        backgroundColor: "rgb(186, 186, 185)",
      },
    },
  }
}));

type MultiSelectProps = {
  options: { label: string; value: string }[];
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  className?: string;
};

const MultiSelect: React.FC<MultiSelectProps> = ({ options, value, onChange, label, placeholder, error, helperText, className = '' }) => {
  const classes = useStyles();

  return (
    <div className={`mb-4 ${className}`}>
      {label ? (
        <label className="block text-white text-sm font-semibold mb-1">{label}</label>
      ) : null}
      <Autocomplete
        size="small"
        multiple
        options={options}
        getOptionLabel={(option) => option.label}
        value={options.filter((option) => value.includes(option.value))}
        onChange={(_, newValue) => onChange(newValue.map((opt) => opt.value))}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            className={classes.root}
            error={error}
            helperText={helperText}
            FormHelperTextProps={{
              classes:{
                root: classes.helperText
              }
            }}
          />
        )}
        renderOption={(option) => (
          <MenuItem className={classes.option}>
            <div className="w-6">
              {value.includes(option.value) ? (
                <IoIosCheckmark size={24} className="p-0 m-0" />
              ) : null}
            </div>
            {option.label}
          </MenuItem>
        )}
        renderTags={(selected, getTagProps) =>
          selected.map((option, index) => (
            <Chip key={option.value} size="small" label={option.label} classes={{ root: classes.chip }} {...getTagProps({ index })} />
          ))
        }
        classes={{ paper: classes.listbox }}
      />
    </div>
  );
};

export default MultiSelect;